import React from "react";
import Logo from "images/logos/nomal/logolight.png"
const LogoSvg = () => {
  return (
      <img src = {Logo} alt="logo" className="w-full block dark:hidden" />
    );
};

export default LogoSvg;
